import { render, staticRenderFns } from "./no-shipping-service-modal.vue?vue&type=template&id=6bb9e074&scoped=true"
import script from "./no-shipping-service-modal.vue?vue&type=script&lang=js"
export * from "./no-shipping-service-modal.vue?vue&type=script&lang=js"
import style0 from "./no-shipping-service-modal.vue?vue&type=style&index=0&id=6bb9e074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb9e074",
  null
  
)

export default component.exports